import { storefrontsNetworkAssignmentSelector } from '@redux/experiments/selectors/storefronts-network';
import { useAppSelector } from '@redux/hooks';
import { useAtomValue } from 'jotai';
import { vendorNetworkCountAtom } from '../jotai/storefront/storefronts-network-pvrec';

export const useIsStorefrontsNetworkEnabled = () => {
	const assignment = useAppSelector(storefrontsNetworkAssignmentSelector);
	const vendorNetworkCount = useAtomValue(vendorNetworkCountAtom);
	return assignment === 'variant1' && vendorNetworkCount > 0;
};
